import { Button, Typography } from "@mui/material";
import { Form, Formik } from "formik";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import * as Yup from "yup";
import { postObservaciones } from "../../../../../../redux/actions/resolucion";
import CardContainer from "../../../../../commons/cards/CardContainer";
import DatosDelEstablecimientoCard from "../../../../../commons/establecimiento/DatosDelEstablecimientoCard";
import FormikTextField from "../../../../../commons/formik/FormikTextField";
import { StyledResolucion } from "../../../../../styled/Prevencion";

const validationSchema = Yup.object({
  descripcionActividadEstablecimiento: Yup.string()
    .required("Campo obligatorio")
    .nullable(),
});

const EstablecimientoCard = ({ title = "Datos del Establecimiento", searchedRes, nextForm, handleCancelResolucion }) => {
  const dispatch = useDispatch();
  const { state } = useLocation();
  const datosEstablecimiento = useSelector(
    (state) => state.resolucion.datosEstablecimiento
  );
  const formulariosPresentados = useSelector(
    (state) => state.resolucion.formulariosPresentados
  );
  const validacionCargaResolucion = useSelector(
    (state) => state.resolucion.validarDisponibilidadCargaRes
  );
  const searchedEstablecimiento = useSelector(
    (state) => state.resolucion.searchedEstablecimiento
  );
  const loadingFormularioAnterior = useSelector(
    (state) => state.resolucion.formularioAnterior.loading
  );
  const observacionesRedux = useSelector(
    (state) => state.resolucion.postResolucion.observaciones
  );

  const [formModel, setFormModel] = useState(null);

  const noHayDatosEstablecimiento = !datosEstablecimiento?.data?.nombre;
  const noBuscoEstablecimiento = !searchedEstablecimiento;
  const hayErrorValidacionResolucion = validacionCargaResolucion?.error;
  const validacionExitosa = searchedEstablecimiento &&
    !validacionCargaResolucion?.loading &&
    !hayErrorValidacionResolucion;

  const noPuedeContinuarCargaRes = state?.idDependenciaEmpleador ?
    loadingFormularioAnterior || noHayDatosEstablecimiento || noBuscoEstablecimiento
    :
    noBuscoEstablecimiento || noHayDatosEstablecimiento || loadingFormularioAnterior || hayErrorValidacionResolucion;

  useEffect(() => {
    if (validacionExitosa && datosEstablecimiento?.data) {
      setFormModel({
        descripcionActividadEstablecimiento: observacionesRedux?.descripcionActividadEstablecimiento?.trim() || "",
      });
    }
  }, [validacionExitosa, datosEstablecimiento?.data, observacionesRedux]);

  const handleSubmit = (values) => {
    dispatch(postObservaciones({
      observacionesGenerales: observacionesRedux?.observacionesGenerales || "Sin Observaciones",
      descripcionActividadEstablecimiento: values.descripcionActividadEstablecimiento,
    }));
    nextForm("Cabecera");
  };

  return (
    <>
      <StyledResolucion.CardsContainer container spacing={2}>
        {searchedRes ? (
          <>
            <StyledResolucion.Card item xs={12}>
              <CardContainer
                title={title}
                loading={datosEstablecimiento.loading}
                componente={
                  <DatosDelEstablecimientoCard
                    data={datosEstablecimiento.data}
                  />
                }
                getData={() => { }}
              />
            </StyledResolucion.Card>
          </>
        ) : (
          <StyledResolucion.LoadingContainer item xs={12} style={{ height: 350 }}>
            <Typography
              style={{
                color: "grey",
                textAlign: "center",
              }}
            >
              Busque un establecimiento.
            </Typography>
          </StyledResolucion.LoadingContainer>
        )}
      </StyledResolucion.CardsContainer>
      {validacionExitosa && formModel ? (
        <Formik
          initialValues={formModel}
          onSubmit={handleSubmit}
          validationSchema={validationSchema}
          enableReinitialize={true}
        >
          <Form>
            <StyledResolucion.FormsContainer style={{ padding: 10 }}>
              <FormikTextField
                multiline
                fullWidth
                maxRows={6}
                minRows={6}
                name="descripcionActividadEstablecimiento"
                id="descripcionActividadEstablecimiento"
                label="Descripción de la Actividad de Establecimiento * (Aquí puede ampliar la actividad realizada en el establecimiento)"
                variant="filled"
              />
            </StyledResolucion.FormsContainer>
            <StyledResolucion.ButtonContainer style={{ padding: 20, width: "auto" }}>
              {
                state?.idDependenciaEmpleador ?
                  <StyledResolucion.CancelButton
                    variant="contained"
                    onClick={handleCancelResolucion}
                  >
                    CANCELAR FORMULARIO
                  </StyledResolucion.CancelButton>
                  : null
              }
              <Button
                color="primary"
                variant="contained"
                type="submit"
                disabled={noPuedeContinuarCargaRes}
              >
                SIGUIENTE
              </Button>
            </StyledResolucion.ButtonContainer>
          </Form>
        </Formik>
      ) : (
        <StyledResolucion.ButtonContainer style={{ padding: 20, width: "auto" }}>
          {
            state?.idDependenciaEmpleador ?
              <StyledResolucion.CancelButton
                variant="contained"
                onClick={handleCancelResolucion}
              >
                CANCELAR FORMULARIO
              </StyledResolucion.CancelButton>
              : null
          }
          <Button
            color="primary"
            variant="contained"
            onClick={() => nextForm("Cabecera")}
            disabled={noPuedeContinuarCargaRes}
          >
            SIGUIENTE
          </Button>
        </StyledResolucion.ButtonContainer>
      )}
    </>
  );
};

export default EstablecimientoCard;
